const keyboardDatePickerActionModalFilter = {
  from: 'From',
  to: 'to'
};

export default keyboardDatePickerActionModalFilter;
